<template>
	<div
		v-editable="blok"
		class="rem:h-[350px] relative cursor-pointer"
		@click="emit('update:isOpen', true); emit('slideData', blok)"
	>
		<NuxtIcon
			v-if="blok.video?.filename?.length || blok.videoUrl"
			name="custom/playVideo"
			class="text-6xl text-shadow-play text-icon-inverse absolute left-[50%] top-[50%] translate-y-[-50%] translate-x-[-50%]"
		/>
		<NuxtPicture
			v-if="blok.image?.filename"
			provider="storyblok"
			width="436"
			height="350"
			:modifiers="storyblokFocusModifiers(blok.image.focus)"
			:src="blok.image.filename"
			:alt="blok.image.alt || ''"
			:sizes="'xs:100vw sm:100vw md:50vw lg:70vw inf:70vw'"
			:img-attrs="{class:'w-full h-full object-cover'}"
			loading="lazy"
		/>
	</div>
</template>

<script setup lang="ts">
	import type {CarouselWithDescriptionSlideStoryblok} from '@/storyblok/types';

	interface Props {
		blok: CarouselWithDescriptionSlideStoryblok
	}

	defineProps<Props>();

	const emit = defineEmits(['update:isOpen', 'slideData']);
</script>
